import React from 'react';
import { Helmet } from 'react-helmet';
import Backdrop from './components/Backdrop';
import Nav from './components/Nav';
import Ticker from './components/Ticker';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import Tokenomics from './components/Tokenomics';
import HowToBuy from './components/HowToBuy';
import Redeem from './components/Redeem';
import Partners from './components/Partners';
import Community from './components/Community';
import Footer from './components/Footer';
import { WalletProvider } from './wallet/WalletContext';

const App = () => (
    <>
      <Helmet>
        <html lang="en" />
        <meta charSet="utf-8" />
        <title>$KEK — Community Meme Token on WAX</title>
        <meta name="description" content="Wax Pepe is a community meme token experience on WAX. This site is for entertainment only and is not an investment product." />
        <meta name="keywords" content="Wax Pepe, $KEK, WAX, meme token, crypto, entertainment" />
        <meta name="theme-color" content="#06090a" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="$KEK — Community Meme Token on WAX" />
        <meta property="og:description" content="Community meme token on WAX. Entertainment only — not an investment product." />
        <meta property="og:image" content="/waxpepewar.webp" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="$KEK — Community Meme Token on WAX" />
        <meta name="twitter:description" content="Community meme token on WAX. Entertainment only — not an investment product." />
        <meta name="twitter:image" content="/waxpepewar.webp" />
      </Helmet>

      <WalletProvider>
        <Backdrop />
        <Nav />
        <Ticker />
        <main>
          <Hero />
          <Stats />
          <About />
          <Tokenomics />
          <HowToBuy />
          <Redeem />
          <Partners />
          <Community />
        </main>
        <Footer />
        <div className="eu-compliance-banner" role="note" aria-label="Jurisdiction notice">
          <strong>Notice:</strong> $KEK is issued for entertainment purposes only, has no intrinsic value, and is not an investment product. This site is not directed to, nor intended for use by, any person in any jurisdiction where doing so would be unlawful. Ensure compliance with your local laws before interacting with crypto-assets.
        </div>
      </WalletProvider>
    </>
);

export default App;
